var map = {
	"./de-DE/dataset-documents": 60716,
	"./en-US/dataset-documents": 27595,
	"./fr-FR/dataset-documents": 75121,
	"./ja-JP/dataset-documents": 12293,
	"./ko-KR/dataset-documents": 79940,
	"./pl-PL/dataset-documents": 97631,
	"./pt-BR/dataset-documents": 62256,
	"./ro-RO/dataset-documents": 37373,
	"./uk-UA/dataset-documents": 41474,
	"./vi-VN/dataset-documents": 63606,
	"./zh-Hans/dataset-documents": 8815,
	"./zh-Hant/dataset-documents": 5589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79444;